export default "__VITE_ASSET__Bt705vqf__"